var map = {
	"./IMG-logo.png": 880,
	"./allianz-logo.png": 58,
	"./berkley-logo.png": 881,
	"./blueCross-logo.png": 71,
	"./canada-life-logo.png": 882,
	"./carewell-logo.png": 509,
	"./desjardins-logo.png": 883,
	"./gms-logo.png": 93,
	"./ia-logo.png": 884,
	"./img-logo2.png": 192,
	"./manulife-logo.png": 885,
	"./rbc-logo.png": 886,
	"./stonewell_logo_KO.png": 887,
	"./stonewell_logo_blk.png": 888,
	"./stonewell_logo_blk_white.png": 889,
	"./stonewell_logo_col.png": 890,
	"./sunlife-logo.png": 891,
	"./travelance-logo.png": 66,
	"./trawick-logo.png": 892,
	"./tugo-logo.png": 54,
	"./worldtrip-logo.png": 893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 879;